<template>
    <div class="footer">
<div class="container mt-5 mb-5">
        <div class="row">
            <div class="col-md-12 col-sm-12 mx-auto partners ">
                <div class="footer-title">{{ $t('partners') }}</div>
                <img src="../assets/img/partners/lfd.png" class="img-fluid" alt="La Ferme Digitale">
                <img src="../assets/img/partners/agrisudouest.jpg" class="img-fluid ml-4" alt="Agri Sud Ouest Innovation">
                <img src="../assets/img/partners/vbca.png" class="img-fluid ml-4" alt="Village by CA">
                <img src="../assets/img/partners/numeum.png" class="img-fluid ml-4" alt="Numeum">
            </div>
        </div>

        <div class="row">
            <div class="col-md-3 col-sm-6">
                <div class="footer-title"><img src="../assets/img/logo_footer.png" class="img-fluid" alt=""></div>
                <div class="footer-link"><img src="../assets/img/iconLocation.png" class="mr-2" alt="iconlocation"><a href="">17 rond-point de l'Europe<br>51430 Bezannes <br>France</a></div>
                <div class="footer-link"><img src="../assets/img/iconMail.png" class="mr-2" alt="iconMail"><a href="mailto:contact@agrivitech.com">contact@agrivitech.com</a></div>
                <div class="footer-link"><i style="color:#22e39e" class="fab fa-discord mr-2"></i> <a href="https://discord.gg/t5GE2wTDSk">https://discord.gg/t5GE2wTDSk</a></div>
                
            </div>
            <div class="col-md-3 col-sm-6">
                <div class="footer-title">{{ $t('footer.solutions') }}</div>
                <div class="footer-link"><router-link to="/solutions/digitappro">{{ $t('footer.dap') }}</router-link></div>
                <div class="footer-link"><router-link to="/solutions/digitappro">{{ $t('footer.nova') }}</router-link></div>
                <div class="footer-link"><router-link to="/solutions/marketplace">{{ $t('footer.mkp') }}</router-link></div>
                <div class="footer-link"><router-link to="/solutions/fleet">{{ $t('footer.fleet') }}</router-link></div>
                <div class="footer-link"><router-link to="/solutions/echangesemences">{{ $t('footer.echag') }}</router-link></div>
                <!-- <div class="footer-link"><a href="">Solutions sur mesure</a></div> -->
            </div>

            <div class="col-md-3 col-sm-6">
                <div class="footer-title">{{ $t('footer.ressources') }}</div>
                <!-- <div class="footer-link"><router-link to="">Aide</router-link></div> -->
                <!-- <div class="footer-link"><router-link to="">Evénements</router-link></div> -->
                <!-- <div class="footer-link"><router-link to="">Chartes graphiques</router-link></div> -->
                 <div class="footer-link"><router-link to="/private"> <i class="fas fa-user-lock"></i> {{ $t('footer.private') }}</router-link> </div>
                 <div class="footer-link"><router-link to="/contact-demo"> {{ $t('footer.demo') }}</router-link> </div>
            </div>

            <div class="col-md-3 col-sm-6">
                <div class="footer-title">{{ $t('footer.entreprise') }}</div>
                <div class="footer-link"><router-link to="/apropos">{{ $t('footer.about') }}</router-link></div>
                <div class="footer-link"><router-link to="/solutions/digitappro/rgpd"> {{ $t('footer.rgpd') }}</router-link></div>
                <!-- <div class="footer-link"><router-link to="/clients">Clients</router-link></div> -->
                <div class="footer-link"><router-link to="/jobs">{{ $t('footer.jobs') }}</router-link></div>
            </div>
            
        </div>
        
        <div class="container bottomBar row">
            <div class="leftPart">
                <a href="">Agrivitech</a>
                <a href="">{{ $t('footer.terms') }}</a>
                <a href="">{{ $t('footer.confidentialite') }}</a>
                <router-link to="/contact">{{ $t('footer.contact') }}</router-link>
            </div>
            <div class="rightPart ml-auto">
                <a href="https://www.linkedin.com/company/agrivitech" target="_blank"><i class="fab fa-linkedin"></i></a>
                <a href="https://www.youtube.com/channel/UCSbojUOYC6b-BF4wqNRIqXA"  target="_blank"><i class="fab fa-youtube-square"></i></a>
                <a href="https://www.facebook.com/agrivitech" target="_blank"><i class="fab fa-facebook-square"></i></a>
                <a href="https://discord.gg/t5GE2wTDSk" target="_blank"><i class="fab fa-discord"></i></a>
            </div>
        </div>
    </div>
    </div>
    
</template>

<script>
export default {
  name: 'Footer',
  props: {}
}



</script>

<style lang="scss" scoped>


.footer-title{
    text-transform: uppercase;
    font-size: 25px;
    margin: 15px 0px;
}
.footer-link{
    margin: 15px 0px;
    opacity: 0.8;
    font-weight: 500;
    a{
        color: var(--mainBlue);
    }
}
.partners{
    margin-bottom: 50px;
    img{
        height: 150px;
    }
    .footer-title{
    text-transform: uppercase;
    font-size: 25px;
    font-weight: 700;
    margin: 15px 0px;
}
}
.bottomBar{
    padding: 100px 0px 0px 0px;

    a{
        color: grey;
    }
    .leftPart{
        a{
            margin-right: 20px;
        }
        text-align: left;
        font-size: 13px;
    }
    .rightPart{
        text-align: right;
        font-size: 20px;
        a{
            margin-left: 20px;
        }
    }
}

</style>